import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
import BusinessVerification from './BusinessVerification';
import BankAccountVerification from './BankAccountVerification';
import KYCVerification from './KYCVerification';
const OnboardingFlow = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [completed, setCompleted] = useState<number[]>([]);
  const navigate = useNavigate();
  const steps = [{
    id: 1,
    name: 'Business Verification',
    component: BusinessVerification
  }, {
    id: 2,
    name: 'Bank Account Verification',
    component: BankAccountVerification
  }, {
    id: 3,
    name: 'KYC Verification',
    component: KYCVerification
  }];
  const handleNext = () => {
    setCompleted([...completed, currentStep]);
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    } else {
      // Onboarding complete
      navigate('/');
    }
  };
  const CurrentStepComponent = steps.find(step => step.id === currentStep)?.component || steps[0].component;
  return <div className="min-h-screen bg-gray-50" data-id="element-812">
      <div className="max-w-4xl mx-auto pt-10 pb-12 px-4 sm:px-6 lg:px-8" data-id="element-813">
        <div className="text-center mb-10" data-id="element-814">
          <h1 className="text-3xl font-extrabold text-gray-900" data-id="element-815">
            Welcome to LucaGet
          </h1>
          <p className="mt-2 text-sm text-gray-600" data-id="element-816">
            Let's get your account set up so you can start receiving payments
          </p>
        </div>
        <div className="mb-8" data-id="element-817">
          <nav aria-label="Progress" data-id="element-818">
            <ol className="space-y-4 md:flex md:space-y-0 md:space-x-8" data-id="element-819">
              {steps.map(step => <li key={step.id} className="md:flex-1" data-id="element-820">
                  <div className={`group pl-4 py-2 flex flex-col border-l-4 md:pl-0 md:pt-4 md:pb-0 md:border-l-0 md:border-t-4 ${currentStep === step.id ? 'border-blue-600' : completed.includes(step.id) ? 'border-green-500' : 'border-gray-200'}`} data-id="element-821">
                    <span className={`text-xs font-semibold tracking-wide uppercase ${currentStep === step.id ? 'text-blue-600' : completed.includes(step.id) ? 'text-green-500' : 'text-gray-500'}`} data-id="element-822">
                      Step {step.id}
                    </span>
                    <span className="text-sm font-medium" data-id="element-823">
                      {step.name}
                      {completed.includes(step.id) && <CheckCircleIcon className="ml-2 h-5 w-5 text-green-500 inline" data-id="element-824" />}
                    </span>
                  </div>
                </li>)}
            </ol>
          </nav>
        </div>
        <div className="bg-white shadow overflow-hidden sm:rounded-md" data-id="element-825">
          <div className="px-4 py-5 sm:p-6" data-id="element-826">
            <CurrentStepComponent onNext={handleNext} data-id="element-827" />
          </div>
        </div>
      </div>
    </div>;
};
export default OnboardingFlow;